import React, {Component, Fragment} from 'react';
import {Helmet} from 'react-helmet';
import NewsList from './NewsList';

class NewsListContainer extends Component {
    render() {
        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'news-list'
                    }}
                >
                    <title>{process.env.REACT_APP_SITE_TITLE} | Actualités</title>
                </Helmet>
                <div className="container">
                    <section id="news-list-title">
                        <div className="row row-title">
                            <div className="col col-md-12 col-sm-8">
                                <h1><span>Nos dernières</span> actualités</h1>
                            </div>
                        </div>
                    </section>

                    <NewsList/>
                </div>
            </Fragment>
        );
    }
}

export default NewsListContainer;



// WEBPACK FOOTER //
// ./src/features/News/components/List/NewsListContainer.js